export const ACTIVITY_RESPONSE_KEYS = {
    SAVE_ACTIVITY_LABEL: 'saveActivity'
};

export const ACTIVITY_TYPES = {
    MILESTONE: 'Milestone'
};

export const ACTIVITY_DEPENDENCIES = {
    lastDependency: 'lastDependency'
};

export const OPTIMISTIC_ID_PREFIX = 'optimistically-added-activity-id-';

export const VALID_UNITS = ['Hours', 'Days', 'Weeks', 'Months', 'Years'];
